export const PaymentMethodSearch = (payment: string): string => {
  switch (payment) {
    case '振替':
      return 'remittance';
    case '振込':
      return 'transfer';
    case 'カード決済':
      return 'card';
    default:
      return '';
  }
};
